<template>
    <component :is="layout">
        <keep-alive :include="['Home']" :max="1">
            <router-view />
        </keep-alive>
    </component>
</template>

<script>
import Entrance from '@/layouts/entrance/Entrance.vue';
import Nothing from '@/layouts/Nothing.vue';
import Default from '@/layouts/default/Default.vue';


export default {
    components: {
        Default,
        Nothing,
        Entrance,
    },
    computed: {
        layout() {
            const layout = this.$route.meta?.layout;

            if (typeof (layout) === 'function')
                return layout(this.$route) || 'Nothing';

            return layout || 'Nothing';
        },
    },
};
</script>
